export var EVENTS = {
	BASKET_SELECTED: 'BASKET_SELECTED'
}